import { render, staticRenderFns } from "./MetaboliteSearch.vue?vue&type=template&id=5b0d5da9&"
import script from "./MetaboliteSearch.vue?vue&type=script&lang=js&"
export * from "./MetaboliteSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports